import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";

export const ReviewCard = ({ review, index = 0, dark = false }) => (
  <Reveal delay={index * 0.08} className="h-full">
    <figure
      data-testid={`review-card-${index}`}
      className={`h-full rounded-xl p-6 border flex flex-col ${
        review.placeholder
          ? "border-dashed border-copper/50 " + (dark ? "bg-coal/60" : "bg-paper/70")
          : dark
            ? "bg-coal border-white/10"
            : "bg-paper border-ink/10 shadow-[0_10px_30px_-18px_rgba(17,17,17,0.25)]"
      }`}
    >
      <Quote size={22} className="text-copper mb-4" aria-hidden="true" />
      <blockquote className={`text-sm leading-relaxed flex-1 ${dark ? "text-white/75" : "text-body/85"}`}>
        {review.text}
      </blockquote>
      <figcaption className="mt-5 flex items-center justify-between gap-3">
        <div>
          <p className={`font-display font-bold text-sm ${dark ? "text-white" : "text-ink"}`}>{review.name}</p>
          <p className={`text-xs mt-0.5 ${dark ? "text-white/40" : "text-mute"}`}>{review.date}</p>
        </div>
        {review.rating ? (
          <span className="flex gap-0.5 text-copper" aria-label={`${review.rating} out of 5 stars`}>
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} size={13} fill={i < review.rating ? "currentColor" : "none"} aria-hidden="true" />
            ))}
          </span>
        ) : (
          <span className="text-[10px] uppercase tracking-[0.2em] text-copper/80 font-semibold">Google</span>
        )}
      </figcaption>
    </figure>
  </Reveal>
);
